<template>
  <v-app>
    <v-main>
      <template v-if="application">
        <map-wrapper v-if="!configureError" />
        <v-img v-else-if="params('draft') === 'true'">
          <v-container class="px-5">
            <v-col class="text-center px-5 mb-5">
              <v-alert
                :value="true"
                type="warning"
                outlined
              >
                <h3>{{ configureError }}</h3>
              </v-alert>
            </v-col>
          </v-container>
        </v-img>
      </template>
    </v-main>
  </v-app>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import MapWrapper from './components/MapWrapper.vue'

  export default {
    name: 'App',
    components: {
      MapWrapper,
    },
    data: () => ({}),
    computed: {
      ...mapState(['application', 'numeratorValueField', 'denominatorValueField']),
      ...mapGetters(['datasetUrl', 'config', 'codeFields']),
      configureError () {
        if (!this.datasetUrl) return 'Veuillez sélectionner une source de données'
        if (!this.codeFields.communes && !this.codeFields.departements && !this.codeFields.regions && !this.codeFields.epci && !this.codeFields.iris) return 'Cette source de données ne contient pas de code commune, département, région, EPCI ou iris'
        if (this.config.numerator.type !== 'count' && !this.numeratorValueField) return 'Veuillez sélectionner au moins une colonne pour le calcul du numérateur'
        if (this.config.denominator.type !== 'none' && this.config.denominator.type !== 'count' && !this.denominatorValueField) return 'Veuillez sélectionner au moins une colonne pour le calcul du dénominateur'
        if (this.config.numerator.propertyField && !this.config.numerator.propertyValue) return 'Veuillez sélectionner une valeur de restriction pour le calcul du numérateur'
        if (this.config.denominator.type !== 'none' && this.config.denominator.propertyField && !this.config.denominator.propertyValue) return 'Veuillez sélectionner une valeur de restriction pour le calcul du dénominateur'
        return null
      },
    },
    mounted () {
      this.$store.dispatch('init')
    },
    methods: {
      params (p) {
        const params = new URLSearchParams(window.location.search)
        return params.get(p)
      },
    },
  }
</script>

<style>
.v-application {
  font-family: "Nunito", sans-serif!important;
}
</style>
